import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import { config } from 'api';

import dynamicYieldAPI from '../services/DynamicYieldAPI';

export default class DynamicYieldLoader extends PureComponent {
  static propTypes = {
    isDynamicYieldEnabled: PropTypes.bool.isRequired,
  }

  get isDYEnabled() {
    const { isDynamicYieldEnabled } = this.props;
    const { dynamicYield: { siteId } = {} } = config;
    const isDyEnabled = isDynamicYieldEnabled && typeof siteId !== 'undefined';

    dynamicYieldAPI.setEnabled(isDyEnabled);
    return isDyEnabled;
  }

  get shouldLoad() {
    const { dynamicYield: { dns, js } = {} } = config;
    return this.isDYEnabled && dns && js;
  }

  loadDns = () => {
    const { dynamicYield: { dns } = {} } = config;
    const links = [];

    dns.forEach(link => {
      // Preconnect links
      links.push(
        <link key={`preconnect-${link}`} rel="preconnect" href={link} />
      );

      // Prefetch links
      links.push(
        <link key={`prefetch-${link}`} rel="dns-prefetch" href={link} />
      );
    });

    return links;
  }

  loadScripts = () => {
    const { dynamicYield: { siteId, js } = {} } = config;
    const scripts = [];

    for (const [name, url] of Object.entries(js)) {
      const scriptId = `dy-api-${name}`;
      scripts.push(
        <script
          key={name}
          id={scriptId}
          data-ot-ignore
          src={url.replace('[site_id]', siteId)}
        />
      );
    }

    return scripts;
  }

  componentDidMount() {
    const { DY } = window;
    dynamicYieldAPI.onLoaded(DY);
  }

  render() {
    if (!this.shouldLoad) {
      return null;
    }

    return (
      <Helmet>
        { this.loadDns() }
        { this.loadScripts() }
      </Helmet>
    );
  }
}
